export const thongBao = {
  title: '通知',
  markAllRead: '全部标为已读',
  deleteAll: '全部删除',
  empty: '暂无通知',
  loadError: '无法加载通知',
  confirmDeleteAll: '确定删除所有通知？',
  ariaLabel: '通知',
  unreadBadge: '{count} 条未读',
  meta: '{type} · {action}',
  byUser: '由 {user}',
  xem: '查看',
  xoa: '删除通知',
  filterAll: '全部',
  filterUnread: '未读',
  markAllReadShort: '全部已读',
  loadMore: '加载更多',
  xemTatCa: '查看全部通知',
  caiDat: '通知设置',
  loai: {
    CODONHANGMOI: '新订单',
    CODONHANGCANNHAT: '待拣货订单',
    CODONHANGCANKIEMTRA: '待检查订单',
    CODONHANGCANDONGGOI: '待打包订单',
    CODONHANGCANDIEUPHOI: '待调度订单',
    CODONHANGCANGIAO: '待配送订单',
    DONHANG_DUOC_SUA: '订单信息已修改',
    CANHBAO_DOI_SOAT: '订单未进入运营',
    GIAO_HANG_THANH_CONG: '配送成功',
    GIAO_HANG_THAT_BAI: '配送失败',
    HOA_DON_MOI: '新发票',
    HOA_DON_SUA: '发票已修改',
    HOA_DON_HUY: '发票已取消或删除',
    PHIEU_THU_CHI_CHO_DUYET: '收/付款单待审批',
    PHIEU_THU_CHI_DA_DUYET: '收/付款单已审批',
    PHIEU_THU_CHI_TU_CHOI: '收/付款单被拒绝',
    YCX_CAN_XU_LY: '开票申请待处理',
    CHUYEN_HANG_DEN: '调拨货物到达',
    DON_HOA_TOC: '新火速订单',
    DON_SHIP_HUY: '承运取消 — 需重新叫车',
    DON_QUA_HAN_GIAO: '逾期未揽收',
  },
  phanHe: {
    KHO: '仓库',
    BAN_HANG: '销售',
  },
  nhomLoai: {
    donHang: '订单',
    canhBao: '警告',
    hoaDon: '发票',
    giaoHang: '配送',
    soQuy: '现金簿',
    xuatHoaDon: '开票',
    chuyenHang: '调拨',
    banOnline: '网店订单',
  },
  caiDatTrang: {
    moTa: '关闭某类型后不再弹出 / 不推送到手机，通知仍保留在列表中。',
    trinhDuyet: '在此浏览器上',
    trinhDuyetMoTa: '仅对当前浏览器生效，不会同步到其他设备。',
    thietBi: '设备',
    thongBaoPhanHe: '{phanHe}通知',
    tomTat: '已接收 {nhan}/{tong}',
    guiThu: '发送测试',
    thuNoiDung: '这是一条测试通知。',
    amThanh: '有新通知时播放声音',
    amThanhMoTa: '每次弹出新通知时发出简短提示音。',
    heThong: '在其他标签页时显示系统通知',
    heThongMoTa: '即使你在使用其他标签页或应用，通知也会显示在屏幕角落。',
    heThongBiChan: '浏览器已阻止通知——请在网站设置中允许。',
    heThongKhongHoTro: '此浏览器不支持系统通知。',
    loaiThongBao: '通知类型',
    khongCoQuyen: '账号尚未获得接收通知的权限。',
    batTatCa: '全部开启',
    tatTatCa: '全部关闭',
    dangNhan: '已开启',
    daTat: '已关闭',
    tatDen: '关闭至 {thoiGian}',
    tamTat: '暂停',
    tat1Gio: '关闭 1 小时',
    tatDen8hSang: '关闭至早上 8:00',
    tatDenKhiBatLai: '关闭直到重新开启',
    batLai: '立即开启',
    luuLoi: '无法保存通知设置',
    taiLoi: '无法加载通知设置',
    phamVi: '接收通知的项目',
    phamViHint: '仅接收已开启的项目 · 点击行可临时支援（网页）',
    phamViTieuDe: '接收通知的项目（网页）',
    phamViMoTa: '仅适用于网页。关闭项目后不弹窗；列表中仍保留。手机端请在 App 中单独设置。',
    phamViTomTat: '正在接收 {nhan}/{tong} 个项目',
    phamViHoTroTam: '正在支援：{danhSach}',
    phamViHoTroDen: '支援至 {thoiGian}',
    phamViHoTro: '临时支援',
    phamViDen1Gio: '1 小时内',
    phamViDen8h: '至早上 8:00',
    phamViDenHetNgay: '至今天结束',
    phamViTatChiNhanh: '停止接收此项目',
    phamViTaiLoi: '无法加载通知范围',
    phamViLuuLoi: '无法保存通知范围',
    phamViTrong: '账号尚未分配任何项目。',
    loaiHint: '关闭后不弹窗 · 点击行可暂停',
    amThanhNgan: '播放提示音',
    heThongNgan: '系统通知',
  },
}
